module.exports = __webpack_public_path__ + "static/img/yuan.45ed459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yuan.png
// module id = egE+
// module chunks = 1